import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { isQueryReady } from "src/api/axiosClient/utils";
import { PostListSchema } from "./types/postList.types";

export const getIngredientPostsKey = "getIngredientPosts" as const;

export const fetchIngredientPosts = async (
    ingredientId: number,
    companyId?: number,
    campaignId?: number,
    itemsPerPage: number = 30,
) => {
    const url = `/api/ingredients/${ingredientId}/ssq-posts`;

    const response = await loggedInApiCall.get(url, {
        headers: {
            Accept: "application/json",
        },
        params: {
            organization_id: companyId ?? undefined,
            campaign: campaignId ?? undefined,
            itemsPerPage: itemsPerPage,
        },
    });

    const posts = response.data;
    const data = zodParseWithDetailedLog(posts, PostListSchema.array(), {
        operation: "GET",
        endpoint: "/ingredients/:id/ssq-posts",
    });
    return data;
};

export const useGetIngredientPosts = (
    ingredientId: number | undefined,
    companyId?: number,
    campaignId?: number,
    itemsPerPage: number = 30,
) => {
    const isEnabled = ingredientId !== undefined;
    const query = useQuery({
        cacheTime: 0,
        queryKey: [getIngredientPostsKey, ingredientId, companyId, campaignId, itemsPerPage],
        enabled: isEnabled,
        keepPreviousData: false,
        queryFn: () => fetchIngredientPosts(ingredientId!, companyId, campaignId, itemsPerPage),
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        posts: query.data,
        isReady,
        ...query,
    };
};
